import { render, staticRenderFns } from "./ShowInternationalEventsSubscription.vue?vue&type=template&id=a9966908&"
import script from "./ShowInternationalEventsSubscription.vue?vue&type=script&lang=js&"
export * from "./ShowInternationalEventsSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports